import React from 'react';
import { motion } from 'framer-motion';
export function Privatize() {
  return <section className="relative py-24 md:py-32 overflow-hidden" data-id="element-154">
      <div className="absolute inset-0 z-0" data-id="element-155">
        <img src="https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&q=80&w=2000" alt="Private Events" className="w-full h-full object-cover opacity-30" data-id="element-156" />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/80 to-obsidian" data-id="element-157" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-8 text-center" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2
      }} data-id="element-159">
          <span className="text-xs md:text-sm tracking-[0.5em] text-champagne uppercase font-sans mb-6 block" data-id="element-160">
            Exclusive Access
          </span>
          <h2 className="text-4xl md:text-7xl font-serif text-white mb-8 leading-tight" data-id="element-161">
            Private Events at the <br className="hidden md:block" data-id="element-162" />
            <span className="italic" data-id="element-163">Temple of DC Nightlife</span>
          </h2>
          <p className="text-white/60 font-sans text-xl md:text-2xl mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-164">
            From intimate gatherings to grand celebrations, our concierge team
            creates bespoke experiences tailored to your every desire. Elevate
            your event in the most exclusive setting in the capital.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 w-full max-w-4xl mx-auto" data-id="element-165">
            <button className="group relative w-full md:w-auto px-8 py-4 overflow-hidden border border-crimson bg-crimson shadow-[0_0_15px_rgba(219,32,39,0.3)]" data-id="element-166">
              <div className="absolute inset-0 bg-white translate-y-full group-hover:translate-y-0 transition-transform duration-500" data-id="element-167" />
              <span className="relative z-10 text-xs md:text-sm uppercase tracking-[0.4em] font-serif text-white group-hover:text-crimson transition-colors duration-500" data-id="element-168">
                Book a Table
              </span>
            </button>

            <button className="group relative w-full md:w-auto px-8 py-4 overflow-hidden border border-crimson shadow-[0_0_15px_rgba(219,32,39,0.1)]" data-id="element-169">
              <div className="absolute inset-0 bg-crimson translate-y-full group-hover:translate-y-0 transition-transform duration-500" data-id="element-170" />
              <span className="relative z-10 text-xs md:text-sm uppercase tracking-[0.4em] font-serif text-crimson group-hover:text-white transition-colors duration-500" data-id="element-171">
                Order Food
              </span>
            </button>

            <button className="group relative w-full md:w-auto px-8 py-4 overflow-hidden border border-crimson shadow-[0_0_15px_rgba(219,32,39,0.1)]" data-id="element-172">
              <div className="absolute inset-0 bg-crimson translate-y-full group-hover:translate-y-0 transition-transform duration-500" data-id="element-173" />
              <span className="relative z-10 text-xs md:text-sm uppercase tracking-[0.4em] font-serif text-crimson group-hover:text-white transition-colors duration-500" data-id="element-174">
                Catering
              </span>
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}